/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import PharmacyReturnBillPayment from './pharmacy-return-bill-payment';
import HospitalOPBillItem from './hospital-op-bill-item';
import PersonName from './person-name';
import DiaglabSampleItemStatus from './diaglab-sample-item-status';
import Admission from './admission';
import AdmissionAdvice from './admission-advice';
import AdmissionEMContacts from './admission-em-contacts';
import AldreteScore from './aldrete-score';
import AllergyLegend from './allergy-legend';
import AllergySymptom from './allergy-symptom';
import ApgarScore from './apgar-score';
import AppointmentHistory from './appointment-history';
import AppointmentStatus from './appointment-status';
import Appointments from './appointments';
import AssessmentAnswer from './assessment-answer';
import AssessmentQuestion from './assessment-question';
import Atendant from './atendant';
import Bed from './bed';
import BedAllotment from './bed-allotment';
import BehaviouralPainScore from './behavioural-pain-score';
import BirthHistory from './birth-history';
import BookingType from './booking-type';
import CashTransaction from './cash-transaction';
import Cholesterol from './cholesterol';
import ChronicCondition from './chronic-condition';
import Combousers from './combousers';
import ConceptDataType from './concept-data-type';
import Consumable from './consumable';
import ConsumableGroup from './consumable-group';
import ConsumableOrder from './consumable-order';
import ConsumableOrderItem from './consumable-order-item';
import ContactDetails from './contact-details';
import Device from './device';
import DeviceManufacurer from './device-manufacurer';
import DeviceType from './device-type';
import DiagLab from './diag-lab';
import DiaglabEquipment from './diaglab-equipment';
import DiagLabPanel from './diag-lab-panel';
import DiagLabPanelItem from './diag-lab-panel-item';
import DiaglabAssistant from './diaglab-assistant';
import DiaglabBill from './diaglab-bill';
import DiaglabBillItem from './diaglab-bill-item';
import DiaglabBillPayment from './diaglab-bill-payment';
import DiaglabHistory from './diaglab-history';
import DiaglabPricing from './diaglab-pricing';
import DiaglabSampleItem from './diaglab-sample-item';
import DiaglabSample from './diaglab-sample';
import DiagnosisHistory from './diagnosis-history';
import DischargeSummary from './discharge-summary';
import Doctor from './doctor';
import DoctorAccess from './doctor-access';
import DoctorAssociation from './doctor-association';
import DoctorAvailability from './doctor-availability';
import DoctorCharges from './doctor-charges';
import DoctorDetails from './doctor-details';
import DoctorDiaglabAssociation from './doctor-diaglab-association';
import DoctorEspecialty from './doctor-especialty';
import DoctorHospitalAssociation from './doctor-hospital-association';
import Duration from './duration';
import Equipment from './equipment';
import EquipmentAllotment from './equipment-allotment';
import EquipmentIP from './equipment-ip';
import EquipmentIPCharges from './equipment-ip-charges';
import Especialty from './especialty';
import FlaccScore from './flacc-score';
import GlobalProperty from './global-property';
import GlucoUser from './gluco-user';
import Glucose from './glucose';
import GrowthLegend from './growth-legend';
import GynicHistory from './gynic-history';
import Hb1ac from './hb-1-ac';
import Hospital from './hospital';
import HospitalAccess from './hospital-access';
import HospitalAccountant from './hospital-accountant';
import HospitalAppointments from './hospital-appointments';
import HospitalAssistant from './hospital-assistant';
import HospitalBill from './hospital-bill';
import HospitalBillDiscount from './hospital-bill-discount';
import HospitalBillItem from './hospital-bill-item';
import HospitalInstitution from './hospital-institution';
import HospitalManager from './hospital-manager';
import HospitalPayment from './hospital-payment';
import HospitalProcedure from './hospital-procedure';
import ICD10Diagnosis from './icd-10-diagnosis';
import ICD10Procedure from './icd-10-procedure';
import IcdDetails from './icd-details';
import ImageTests from './image-tests';
import Implant from './implant';
import ImplantGroup from './implant-group';
import ImplantOrder from './implant-order';
import ImplantOrderItem from './implant-order-item';
import ImplantProperty from './implant-property';
import Instance from './instance';
import Institution from './institution';
import InsuranceClaim from './insurance-claim';
import InsuranceClaimHistory from './insurance-claim-history';
import InsuranceClaimItem from './insurance-claim-item';
import InsurancePolicy from './insurance-policy';
import IntraOPChart from './intra-op-chart';
import IntraOPCount from './intra-op-count';
import IntraOPNursingRecord from './intra-op-nursing-record';
import IntraOPPack from './intra-op-pack';
import IntraOPRecovery from './intra-op-recovery';
import Ketone from './ketone';
import LabAccess from './lab-access';
import LabDepartment from './lab-department';
import LabDepartmentItem from './lab-department-item';
import LabHospitalAssociation from './lab-hospital-association';
import LabItemMeasure from './lab-item-measure';
import LabPrescription from './lab-prescription';
import LabTestCategory from './lab-test-category';
import LabTestCategoryGroup from './lab-test-category-group';
import LabTestCategoryItem from './lab-test-category-item';
import LabTestGroupItem from './lab-test-group-item';
import LabTestItem from './lab-test-item';
import LabTestItemLimit from './lab-test-item-limit';
import MPPS from './mpps';
import MWLItem from './mwl-item';
import Meal from './meal';
import MealAdvise from './meal-advise';
import MealDetails from './meal-details';
import MealNutrition from './meal-nutrition';
import MealPlan from './meal-plan';
import MealSchedule from './meal-schedule';
import MedicalAssociation from './medical-association';
import MedicalHistory from './medical-history';
import MedicationDetails from './medication-details';
import MedicationMedicines from './medication-medicines';
import MedicationSchedule from './medication-schedule';
import MedicationScheduleDetails from './medication-schedule-details';
import Medicine from './medicine';
import ModuleLogo from './module-logo';
import NipsScore from './nips-score';
import Nurse from './nurse';
import NursingNotes from './nursing-notes';
import NutritionIP from './nutrition-ip';
import NutritionOrder from './nutrition-order';
import NutritionOrderItem from './nutrition-order-item';
import NutritionPlan from './nutrition-plan';
import NutritionPlanIP from './nutrition-plan-ip';
import Nutritionist from './nutritionist';
import Nutrtion from './nutrtion';
import Nutrtiontags from './nutrtiontags';
import ObstetricEvent from './obstetric-event';
import OpMedication from './op-medication';
import OtherVitals from './other-vitals';
import PaediatricParams from './paediatric-params';
import PatientCondition from './patient-condition';
import PatientConditionCheckUp from './patient-condition-check-up';
import PatientIdentifierName from './patient-identifier-name';
import PatientIdentifier from './patient-identifier';
import PatientIdentifierType from './patient-identifier-type';
import PatientMarker from './patient-marker';
import PatientNutritionPlan from './patient-nutrition-plan';
import PatientProcedure from './patient-procedure';
import PatientProcedureConsumable from './patient-procedure-consumable';
import PatientProcedureImplant from './patient-procedure-implant';
import PatientProcedureMedicine from './patient-procedure-medicine';
import PatientProcedureOrder from './patient-procedure-order';
import PatientProcedurePlan from './patient-procedure-plan';
import PatientProcedureInvestigation from './patient-procedure-investigation';
import PatientSurvey from './patient-survey';
import PatientSurveySections from './patient-survey-sections';
import PatientVolunteer from './patient-volunteer';
import PaymentScheme from './payment-scheme';
import PatientName from './patient-name';
import Pharmacist from './pharmacist';
import Pharmacy from './pharmacy';
import PharmacyAccess from './pharmacy-access';
import PharmacyBill from './pharmacy-bill';
import PharmacyBillItem from './pharmacy-bill-item';
import PharmacyBillPayment from './pharmacy-bill-payment';
import PharmacyConsumableBillItem from './pharmacy-consumable-bill-item';
import PharmacyConsumableRefundBillItem from './pharmacy-consumable-refund-bill-item';
import PharmacyConsumableStock from './pharmacy-consumable-stock';
import PharmacyDrugBrandNames from './pharmacy-drug-brand-names';
import PharmacyHistory from './pharmacy-history';
import PharmacyHospitalAssociation from './pharmacy-hospital-association';
import PharmacyImplantBillItem from './pharmacy-implant-bill-item';
import PharmacyImplantRefundBillItem from './pharmacy-implant-refund-bill-item';
import PharmacyImplantStock from './pharmacy-implant-stock';
import PharmacyPaymentHistory from './pharmacy-payment-history';
import PharmacyRefundBill from './pharmacy-refund-bill';
import PharmacyRefundBillItem from './pharmacy-refund-bill-item';
import PharmacyRefundPayment from './pharmacy-refund-payment';
import PharmacyStock from './pharmacy-stock';
import PharmacyStockBill from './pharmacy-stock-bill';
import PharmacySuppliers from './pharmacy-suppliers';
import PhysioCategory from './physio-category';
import PhysioCategoryItem from './physio-category-item';
import PhysioItem from './physio-item';
import PhysioOrder from './physio-order';
import PhysioOrderItem from './physio-order-item';
import PhysioTherapist from './physio-therapist';
import PostOPInstruction from './post-op-instruction';
import PostOPRecoveryRecord from './post-op-recovery-record';
import PostOPSurgeonNotes from './post-op-surgeon-notes';
import PostOpRecovery from './post-op-recovery';
import PostOpRecoveryDischarge from './post-op-recovery-discharge';
import PreAssessment from './pre-assessment';
import PreOPTimeOut from './pre-op-time-out';
import PreOpAddlAssessment from './pre-op-addl-assessment';
import PreOpAnaesthesiaChart from './pre-op-anaesthesia-chart';
import PreOpAssessment from './pre-op-assessment';
import PreOpCheckList from './pre-op-check-list';
import PreOpInstructions from './pre-op-instructions';
import PreOpReviewPAC from './pre-op-review-pac';
import PreOpSignIn from './pre-op-sign-in';
import Prescription from './prescription';
import PrescriptionSpecVital from './prescription-spec-vital';
import Pressure from './pressure';
import ProcedureBloodProducts from './procedure-blood-products';
import ProcedureConsumable from './procedure-consumable';
import ProcedureImplant from './procedure-implant';
import ProcedureMedicine from './procedure-medicine';
import ProcedureMonitors from './procedure-monitors';
import ProcedurePrice from './procedure-price';
import ProcedureInvestigation from './procedure-investigation';
import ProvidedItem from './provided-item';
import RadiologyBillItem from './radiology-bill-item';
import RadiologyPricing from './radiology-pricing';
import RadiologyReport from './radiology-report';
import RadiologyReportTemplate from './radiology-report-template';
import RadiologyStudy from './radiology-study';
import Recipe from './recipe';
import RecipeTags from './recipe-tags';
import Referral from './referral';
import Relation from './relation';
import Relatives from './relatives';
import ReminderOptions from './reminder-options';
import Reminders from './reminders';
import Roles from './roles';
import Room from './room';
import Saluation from './saluation';
import Series from './series';
import SpecialityVitals from './speciality-vitals';
import Study from './study';
import SubscriptionBilling from './subscription-billing';
import SubscriptionPayment from './subscription-payment';
import SubscriptionPlan from './subscription-plan';
import SurveyAnswer from './survey-answer';
import SurveyComments from './survey-comments';
import SurveyHeaders from './survey-headers';
import SurveyInputType from './survey-input-type';
import SurveyOptionChoice from './survey-option-choice';
import SurveyOptionGroup from './survey-option-group';
import SurveyQuestion from './survey-question';
import SurveyQuestionOption from './survey-question-option';
import SurveySections from './survey-sections';
import SurveyUnitsOfMeasure from './survey-units-of-measure';
import TemplateDiagnosis from './template-diagnosis';
import TemplateInvestigation from './template-investigation';
import TemplateMedication from './template-medication';
import TemplatePrescription from './template-prescription';
import TemplateSchedule from './template-schedule';
import TreatmentHistory from './treatment-history';
import TreatmentNotes from './treatment-notes';
import TreatmentPlan from './treatment-plan';
import UserAdditionalHistory from './user-additional-history';
import UserAllergies from './user-allergies';
import UserLabItemEnum from './user-lab-item-enum';
import UserLabTestItem from './user-lab-test-item';
import UserPanelItem from './user-panel-item';
import UserRoles from './user-roles';
import UserVaccinationScheduleDetails from './user-vaccination-schedule-details';
import Vaccination from './vaccination';
import VaccinationSchedule from './vaccination-schedule';
import VaccinationScheduleDetails from './vaccination-schedule-details';
import Vitals from './vitals';
import VolunteerVisits from './volunteer-visits';
import Ward from './ward';
import WardCharges from './ward-charges';
import Weight from './weight';
import WongBakersPainScore from './wong-bakers-pain-score';
import EntityAttribute from './entity-attribute';
import PharmacyLimit from './pharmacy-limit';
import OperationTheatre from './operation-theatre';
import SurgicalAppointment from './surgical-appointment';
import SurgicalAppointmentAttributeType from './surgical-appointment-attribute-type';
import SurgicalAppointmentAttribute from './surgical-appointment-attribute';
import PharmacyReturnBill from './pharmacy-return-bill';
import PharmacyReturnBillItem from './pharmacy-return-bill-item';
import PharmacyConsumableReturnBillItem from './pharmacy-consumable-return-bill-item';
import PharmacyImplantReturnBillItem from './pharmacy-implant-return-bill-item';
import PharmacyVendorPaymentTracker from './pharmacy-vendor-payment-tracker';
import OPCharge from './op-charge';
import PharmacyCredit from './pharmacy-credit';
import PackageSubscription from './package-subscription';
import PackageSubscriber from './package-subscriber';
import PackageSubscriptionDiscount from './package-subscription-discount';
import PackagePaymentHistory from './package-payment-history';
import PatientAccessGroup from './patient-access-group';
import PharmacyAuditSummary from './pharmacy-audit-summary';
import PharmacyAuditItem from './pharmacy-audit-item';
import PackageMedicine from './package-medicine';
import CustomerCareExecutive from './customer-care-executive';
import EventImage from './event-image';
import DentalTooth from './dental-tooth';
import DentalSurface from './dental-surface';
import DentalToothSurface from './dental-tooth-surface';
import DentalMouthItem from './dental-mouth-item';
import DentalSurfaceErosion from './dental-surface-erosion';
import DentalExamAndTreatment from './dental-exam-and-treatment';
import PharmacyKit from './pharmacy-kit';
import PharmacyKitItem from './pharmacy-kit-item';
import ProcedureEpisode from './procedure-episode';
import PatientProcedureEpisode from './patient-procedure-episode';
import TreatmentProcedure from './treatment-procedure';
import PharmacyStockClosure from './pharmacy-stock-closure';
import LensSpecification from './lens-specification';
import LensPrescription from './lens-prescription';
import OpProcedureOrder from './op-procedure-order';
import OpProcedureOrderItem from './op-procedure-order-item';
import AppointmentEpisode from './appointment-episode';
import Bleeding from './bleeding';
import Cervix from './cervix';
import CycleDay from './cycle-day';
import FamilyHistory from './family-history';
import GynaecHistory from './gynaec-history';
import MedicationHistory from './medication-history';
import MensesEvent from './menses-event';
import Mucus from './mucus';
import Ovulation from './ovulation';
import Pain from './pain';
import PastMedicalHistory from './past-medical-history';
import PatientSymptomHistory from './patient-symptom-history';
import PostDeliveryMonitoring from './post-delivery-monitoring';
import PregnancyCase from './pregnancy-case';
import PregnancyPrescription from './pregnancy-prescription';
import PregnancyVaccine from './pregnancy-vaccine';
import HabitsHistory from './habits-history';
import SexualHistory from './sexual-history';
import SpecialitySymptomPreferences from './speciality-symptom-preferences';
import SurgicalHistory from './surgical-history';
import Symptom from './symptom';
import Temperature from './temperature';
import TrimesterObservation from './trimester-observation';
import PatientAttributeType from './patient-attribute-type';
import PatientAttribute from './patient-attribute';
import Paramedic from './paramedic';
import ParamedicReferral from './paramedic-referral';
import ParamedicReferralCharge from './paramedic-referral-charge';
import ParamedicReferralPayment from './paramedic-referral-payment';
import ParamedicHospitalAssociation from './paramedic-hospital-association';
import UrlSlug from './url-slug';
import FacilityLocation from './facility-location';
import ParamedicAccess from './paramedic-access';
import PharmacyStockIndentItem from './pharmacy-stock-indent-item';
import PharmacyStockIndentMap from './pharmacy-stock-indent-map';
import DiagLabInventoryType from './diag-lab-inventory-type';
import DiagLabInventory from './diag-lab-inventory';
import DiagLabInventoryInvestigation from './diag-lab-inventory-investigation';
import DiagLabSupplier from './diag-lab-supplier';
import PharmacyStockIndent from './pharmacy-stock-indent';
import DiagLabInventoryCheckout from './diag-lab-inventory-checkout';
import Language from './language';
import Trimester from './trimester';
import ParamedicOrder from './paramedic-order';
import DoctorLanguage from './doctor-language';
import LaborIncident from './labor-incident';
import LaborProgression from './labor-progression';
import TrimesterObservationParam from './trimester-observation-param';
import SpecVitalResult from './spec-vital-result';
import AdmissionAuxPatient from './admission-aux-patient';
import AdmissionConsultant from './admission-consultant';
import GynaecChecklist from './gynaec-checklist';
import PatientCategory from './patient-category';
import MiscCharges from './misc-charges';
import HospitalPatientCategoryAttributes from './hospital-patient-category-attributes';
import HospPatientCatMiscCharges from './hosp-patient-cat-misc-charges';
import HospitalPatientAttribute from './hospital-patient-attribute';
import DoctorHospitalAttribute from './doctor-hospital-attribute';
import DayOff from './day-off';
import Department from './department';
import NurseDepartment from './nurse-department';
import DepartmentNeed from './department-need';
import NurseAttribute from './nurse-attribute';
import Schedule from './schedule';
import Shift from './shift';
import DepartmentWard from './department-ward';
import PaymentCommunity from './payment-community';
import SchemeCommunity from './scheme-community';
import DepartmentSpeciality from './department-speciality';
import DiagLabInventoryBill from './diag-lab-inventory-bill';
import SymptomAttributePreference from './symptom-attribute-preference';
import SymptomAttribute from './symptom-attribute';
import PatientSymptomAttribute from './patient-symptom-attribute';
import ConceptTerms from './concept-terms';
import UserAttribute from './user-attribute';
import PharmacyConsumer from './pharmacy-consumer';
import PharmacyExternalOrder from './pharmacy-external-order';
import PharmacyExternalOrderItem from './pharmacy-external-order-item';
import PharmacyExternalOrderShipment from './pharmacy-external-order-shipment';
import PharmacyExternalOrderShipmentItem from './pharmacy-external-order-shipment-item';
import Eye from './eye';
import PharmacyMiscBillItem from './pharmacy-misc-bill-item';
import TumorMeasurement from './tumor-measurement';
import ClinicalDictionaryType from './clinical-dictionary-type';
import ClinicalDictionary from './clinical-dictionary';
import Tumor from './tumor';
import TumorSource from './tumor-source';
import TreatmentTemplate from './treatment-template';
import TreatmentTemplateComponent from './treatment-template-component';
import Regimen from './regimen';
import RegimenChecklistItem from './regimen-checklist-item';
import RadiationType from './radiation-type';
import RadiationTechnique from './radiation-technique';
import DosageGuideline from './dosage-guideline';
import DosageDilution from './dosage-dilution';
import Frequency from './frequency';
import Sequence from './sequence';
import RegimenDrug from './regimen-drug';
import RadiationSession from './radiation-session';
import OrganAtRisk from './organ-at-risk';
import RadiationConstraint from './radiation-constraint';
import RadiationBeamParameter from './radiation-beam-parameter';
import RadiationDosimetry from './radiation-dosimetry';
import RegimenCycle from './regimen-cycle';
import RegimenAdverseEvent from './regimen-adverse-event';
import DrugConstraint from './drug-constraint';
import TreatmentDeliveryPlan from './treatment-delivery-plan';
import TreatmentRegimen from './treatment-regimen';
import TreatmentCycle from './treatment-cycle';
import TreatmentCycleCheckListItem from './treatment-cycle-check-list-item';
import TreatmentDrug from './treatment-drug';
import TreatmentRadiation from './treatment-radiation';
import TreatmentRadiationBeamParam from './treatment-radiation-beam-param';
import TreatmentRadiationDosimetry from './treatment-radiation-dosimetry';
import TreatmentOrganAtRisk from './treatment-organ-at-risk';
import TreatmentTumor from './treatment-tumor';
import TreatmentRadiationTechnique from './treatment-radiation-technique';
import TreatmentContouring from './treatment-contouring';
import TreatmentAssessment from './treatment-assessment';
import TreatmentAdverseEvent from './treatment-adverse-event';
import TumorBoard from './tumor-board';
import TumorBoardMember from './tumor-board-member';
import TumorStaging from './tumor-staging';
import TumorBoardOccurrenceParticipant from './tumor-board-occurrence-participant';
import TumorBoardOutcome from './tumor-board-outcome';
import TumorBoardParticipantOutcome from './tumor-board-participant-outcome';
import TumorBoardReferral from './tumor-board-referral';
import TumorBoardOccurrence from './tumor-board-occurrence';
import TumorBoardPatient from './tumor-board-patient';
import DoctorAvailabilitySlot from './doctor-availability-slot';
import BedAllotmentCharge from './bed-allotment-charge';
import EquipmentAllotmentCharge from './equipment-allotment-charge';
import PatientProcedureCharge from './patient-procedure-charge';
import ProductTag from './product-tag';
import TenantPaymentGateway from './tenant-payment-gateway';
import PaymentGateway from './payment-gateway';
import TenantGatewayTransaction from './tenant-gateway-transaction';
import PharmacySupplierAttribute from './pharmacy-supplier-attribute';
import IntraOPInvestigation from './intra-op-investigation';
import ProductAttributeType from './product-attribute-type';
import ProductAttribute from './product-attribute';
import SampleContainerType from './sample-container-type';
import HospitalProcedureSpeciality from './hospital-procedure-speciality';
import WorkFlowProtocol from './work-flow-protocol';
import WorkFlowStep from './work-flow-step';
import WorkFlowProtocolLog from './work-flow-protocol-log';
import AccountingCurrency from './accounting-currency';
import AccountingTransaction from './accounting-transaction';
import AccountingReconciliation from './accounting-reconciliation';
import AccountingCollectionLedger from './accounting-collection-ledger';
import AccountingTransactionBill from './accounting-transaction-bill';
import AccountingExpenseLedger from './accounting-expense-ledger';
import AccountingTax from './accounting-tax';
import WorkFlowStepLog from './work-flow-step-log';
import AccountingBankAccount from './accounting-bank-account';
import PharmacySaleCredit from './pharmacy-sale-credit';
import SampleContainerTestSample from './sample-container-test-sample';
import OperationTheatreEquipment from './operation-theatre-equipment';
import PharmacySaleCreditPaymentTracker from './pharmacy-sale-credit-payment-tracker';
import DiaglabDepartmentAccess from './diaglab-department-access';
import LabTestItemAttribute from './lab-test-item-attribute';
import RxCalculatorFormula from './rx-calculator-formula';
import DiaglabTestThreshold from './diaglab-test-threshold';
import TreatmentSessionVitals from './treatment-session-vitals';
import RegimenInvestigation from './regimen-investigation';
import TreatmentRegimenInvestigation from './treatment-regimen-investigation';
import TreatmentRegimenInvestigationObs from './treatment-regimen-investigation-obs';
import CatalogDefinitions from './catalog-definitions';
import Organism from './organism';
import Antibiotic from './antibiotic';
import LabTestItemOrganismAntibiotic from './lab-test-item-organism-antibiotic';
import PatientOrganismAntibioticSusceptibility from './patient-organism-antibiotic-susceptibility';
import ResistanceTrend from './resistance-trend';
import BloodBankInventory from './blood-bank-inventory';
import BloodBankRequest from './blood-bank-request';
import BloodInventoryRequestMap from './blood-inventory-request-map';
import BloodBank from './blood-bank';
import BloodBankEmployee from './blood-bank-employee';
import BloodDonation from './blood-donation';
import BloodDonorFitness from './blood-donor-fitness';
import HealthCamp from './health-camp';
import BloodInventoryInvestigation from './blood-inventory-investigation';
import BloodBankInvestigationList from './blood-bank-investigation-list';
import BloodBankAccess from './blood-bank-access';
import BloodBankAssociation from './blood-bank-association';
import BloodBankAdverseEvent from './blood-bank-adverse-event';
import IntegrationChannel from './integration-channel';
import IntegrationEndpoint from './integration-endpoint';
import IntegrationEndpointAttribute from './integration-endpoint-attribute';
import IntegrationTemplate from './integration-template';
import TenantIntegrationChannel from './tenant-integration-channel';
import TenantIntegrationEndpointAttribute from './tenant-integration-endpoint-attribute';
import TenantIntegrationTemplate from './tenant-integration-template';
import CommunicationLog from './communication-log';
import DataCategory from './data-category';
import IntegrationTemplateCategory from './integration-template-category';
import TenantIntegrationTemplateCategory from './tenant-integration-template-category';
import HospitalProcedureItem from './hospital-procedure-item';
import HealthCampParticipant from './health-camp-participant';
import HealthCampTransaction from './health-camp-transaction';
import ApprovedRefund from './approved-refund';
import ExternalReferral from './external-referral';
import HealthCampRegistration from './health-camp-registration';
import Tenant from './tenant';
import TenantEmployee from './tenant-employee';
import TenantAccess from './tenant-access';
import TenantAssociation from './tenant-association';
import TinymedicPatientOrder from './tinymedic-patient-order';
import TenantBids from './tenant-bids';
import TenantBidItem from './tenant-bid-item';
import TenantBidPayment from './tenant-bid-payment';
import TenantBidShipment from './tenant-bid-shipment';
import TinymedicPatientOrderFile from './tinymedic-patient-order-file';
import DoctorRegularMedicine from './doctor-regular-medicine';
import DoctorRegularInvestigation from './doctor-regular-investigation';
/* jhipster-needle-add-route-import - JHipster will add routes here */

export default () => {
  return (
    <div>
      <ErrorBoundaryRoutes>
        {/* prettier-ignore */}
        <Route path="pharmacy-return-bill-payment/*" element={<PharmacyReturnBillPayment />} />
        <Route path="hospital-op-bill-item/*" element={<HospitalOPBillItem />} />
        <Route path="person-name/*" element={<PersonName />} />
        <Route path="diaglab-sample-item-status/*" element={<DiaglabSampleItemStatus />} />
        <Route path="admission/*" element={<Admission />} />
        <Route path="admission-advice/*" element={<AdmissionAdvice />} />
        <Route path="admission-em-contacts/*" element={<AdmissionEMContacts />} />
        <Route path="aldrete-score/*" element={<AldreteScore />} />
        <Route path="allergy-legend/*" element={<AllergyLegend />} />
        <Route path="allergy-symptom/*" element={<AllergySymptom />} />
        <Route path="apgar-score/*" element={<ApgarScore />} />
        <Route path="appointment-history/*" element={<AppointmentHistory />} />
        <Route path="appointment-status/*" element={<AppointmentStatus />} />
        <Route path="appointments/*" element={<Appointments />} />
        <Route path="assessment-answer/*" element={<AssessmentAnswer />} />
        <Route path="assessment-question/*" element={<AssessmentQuestion />} />
        <Route path="atendant/*" element={<Atendant />} />
        <Route path="bed/*" element={<Bed />} />
        <Route path="bed-allotment/*" element={<BedAllotment />} />
        <Route path="behavioural-pain-score/*" element={<BehaviouralPainScore />} />
        <Route path="birth-history/*" element={<BirthHistory />} />
        <Route path="booking-type/*" element={<BookingType />} />
        <Route path="cash-transaction/*" element={<CashTransaction />} />
        <Route path="cholesterol/*" element={<Cholesterol />} />
        <Route path="chronic-condition/*" element={<ChronicCondition />} />
        <Route path="combousers/*" element={<Combousers />} />
        <Route path="concept-data-type/*" element={<ConceptDataType />} />
        <Route path="consumable/*" element={<Consumable />} />
        <Route path="consumable-group/*" element={<ConsumableGroup />} />
        <Route path="consumable-order/*" element={<ConsumableOrder />} />
        <Route path="consumable-order-item/*" element={<ConsumableOrderItem />} />
        <Route path="contact-details/*" element={<ContactDetails />} />
        <Route path="device/*" element={<Device />} />
        <Route path="device-manufacurer/*" element={<DeviceManufacurer />} />
        <Route path="device-type/*" element={<DeviceType />} />
        <Route path="diag-lab/*" element={<DiagLab />} />
        <Route path="diaglab-equipment/*" element={<DiaglabEquipment />} />
        <Route path="diag-lab-panel/*" element={<DiagLabPanel />} />
        <Route path="diag-lab-panel-item/*" element={<DiagLabPanelItem />} />
        <Route path="diaglab-assistant/*" element={<DiaglabAssistant />} />
        <Route path="diaglab-bill/*" element={<DiaglabBill />} />
        <Route path="diaglab-bill-item/*" element={<DiaglabBillItem />} />
        <Route path="diaglab-bill-payment/*" element={<DiaglabBillPayment />} />
        <Route path="diaglab-history/*" element={<DiaglabHistory />} />
        <Route path="diaglab-pricing/*" element={<DiaglabPricing />} />
        <Route path="diaglab-sample-item/*" element={<DiaglabSampleItem />} />
        <Route path="diaglab-sample/*" element={<DiaglabSample />} />
        <Route path="diagnosis-history/*" element={<DiagnosisHistory />} />
        <Route path="discharge-summary/*" element={<DischargeSummary />} />
        <Route path="doctor/*" element={<Doctor />} />
        <Route path="doctor-access/*" element={<DoctorAccess />} />
        <Route path="doctor-association/*" element={<DoctorAssociation />} />
        <Route path="doctor-availability/*" element={<DoctorAvailability />} />
        <Route path="doctor-charges/*" element={<DoctorCharges />} />
        <Route path="doctor-details/*" element={<DoctorDetails />} />
        <Route path="doctor-diaglab-association/*" element={<DoctorDiaglabAssociation />} />
        <Route path="doctor-especialty/*" element={<DoctorEspecialty />} />
        <Route path="doctor-hospital-association/*" element={<DoctorHospitalAssociation />} />
        <Route path="duration/*" element={<Duration />} />
        <Route path="equipment/*" element={<Equipment />} />
        <Route path="equipment-allotment/*" element={<EquipmentAllotment />} />
        <Route path="equipment-ip/*" element={<EquipmentIP />} />
        <Route path="equipment-ip-charges/*" element={<EquipmentIPCharges />} />
        <Route path="especialty/*" element={<Especialty />} />
        <Route path="flacc-score/*" element={<FlaccScore />} />
        <Route path="global-property/*" element={<GlobalProperty />} />
        <Route path="gluco-user/*" element={<GlucoUser />} />
        <Route path="glucose/*" element={<Glucose />} />
        <Route path="growth-legend/*" element={<GrowthLegend />} />
        <Route path="gynic-history/*" element={<GynicHistory />} />
        <Route path="hb-1-ac/*" element={<Hb1ac />} />
        <Route path="hospital/*" element={<Hospital />} />
        <Route path="hospital-access/*" element={<HospitalAccess />} />
        <Route path="hospital-accountant/*" element={<HospitalAccountant />} />
        <Route path="hospital-appointments/*" element={<HospitalAppointments />} />
        <Route path="hospital-assistant/*" element={<HospitalAssistant />} />
        <Route path="hospital-bill/*" element={<HospitalBill />} />
        <Route path="hospital-bill-discount/*" element={<HospitalBillDiscount />} />
        <Route path="hospital-bill-item/*" element={<HospitalBillItem />} />
        <Route path="hospital-institution/*" element={<HospitalInstitution />} />
        <Route path="hospital-manager/*" element={<HospitalManager />} />
        <Route path="hospital-payment/*" element={<HospitalPayment />} />
        <Route path="hospital-procedure/*" element={<HospitalProcedure />} />
        <Route path="icd-10-diagnosis/*" element={<ICD10Diagnosis />} />
        <Route path="icd-10-procedure/*" element={<ICD10Procedure />} />
        <Route path="icd-details/*" element={<IcdDetails />} />
        <Route path="image-tests/*" element={<ImageTests />} />
        <Route path="implant/*" element={<Implant />} />
        <Route path="implant-group/*" element={<ImplantGroup />} />
        <Route path="implant-order/*" element={<ImplantOrder />} />
        <Route path="implant-order-item/*" element={<ImplantOrderItem />} />
        <Route path="implant-property/*" element={<ImplantProperty />} />
        <Route path="instance/*" element={<Instance />} />
        <Route path="institution/*" element={<Institution />} />
        <Route path="insurance-claim/*" element={<InsuranceClaim />} />
        <Route path="insurance-claim-history/*" element={<InsuranceClaimHistory />} />
        <Route path="insurance-claim-item/*" element={<InsuranceClaimItem />} />
        <Route path="insurance-policy/*" element={<InsurancePolicy />} />
        <Route path="intra-op-chart/*" element={<IntraOPChart />} />
        <Route path="intra-op-count/*" element={<IntraOPCount />} />
        <Route path="intra-op-nursing-record/*" element={<IntraOPNursingRecord />} />
        <Route path="intra-op-pack/*" element={<IntraOPPack />} />
        <Route path="intra-op-recovery/*" element={<IntraOPRecovery />} />
        <Route path="ketone/*" element={<Ketone />} />
        <Route path="lab-access/*" element={<LabAccess />} />
        <Route path="lab-department/*" element={<LabDepartment />} />
        <Route path="lab-department-item/*" element={<LabDepartmentItem />} />
        <Route path="lab-hospital-association/*" element={<LabHospitalAssociation />} />
        <Route path="lab-item-measure/*" element={<LabItemMeasure />} />
        <Route path="lab-prescription/*" element={<LabPrescription />} />
        <Route path="lab-test-category/*" element={<LabTestCategory />} />
        <Route path="lab-test-category-group/*" element={<LabTestCategoryGroup />} />
        <Route path="lab-test-category-item/*" element={<LabTestCategoryItem />} />
        <Route path="lab-test-group-item/*" element={<LabTestGroupItem />} />
        <Route path="lab-test-item/*" element={<LabTestItem />} />
        <Route path="lab-test-item-limit/*" element={<LabTestItemLimit />} />
        <Route path="mpps/*" element={<MPPS />} />
        <Route path="mwl-item/*" element={<MWLItem />} />
        <Route path="meal/*" element={<Meal />} />
        <Route path="meal-advise/*" element={<MealAdvise />} />
        <Route path="meal-details/*" element={<MealDetails />} />
        <Route path="meal-nutrition/*" element={<MealNutrition />} />
        <Route path="meal-plan/*" element={<MealPlan />} />
        <Route path="meal-schedule/*" element={<MealSchedule />} />
        <Route path="medical-association/*" element={<MedicalAssociation />} />
        <Route path="medical-history/*" element={<MedicalHistory />} />
        <Route path="medication-details/*" element={<MedicationDetails />} />
        <Route path="medication-medicines/*" element={<MedicationMedicines />} />
        <Route path="medication-schedule/*" element={<MedicationSchedule />} />
        <Route path="medication-schedule-details/*" element={<MedicationScheduleDetails />} />
        <Route path="medicine/*" element={<Medicine />} />
        <Route path="module-logo/*" element={<ModuleLogo />} />
        <Route path="nips-score/*" element={<NipsScore />} />
        <Route path="nurse/*" element={<Nurse />} />
        <Route path="nursing-notes/*" element={<NursingNotes />} />
        <Route path="nutrition-ip/*" element={<NutritionIP />} />
        <Route path="nutrition-order/*" element={<NutritionOrder />} />
        <Route path="nutrition-order-item/*" element={<NutritionOrderItem />} />
        <Route path="nutrition-plan/*" element={<NutritionPlan />} />
        <Route path="nutrition-plan-ip/*" element={<NutritionPlanIP />} />
        <Route path="nutritionist/*" element={<Nutritionist />} />
        <Route path="nutrtion/*" element={<Nutrtion />} />
        <Route path="nutrtiontags/*" element={<Nutrtiontags />} />
        <Route path="obstetric-event/*" element={<ObstetricEvent />} />
        <Route path="op-medication/*" element={<OpMedication />} />
        <Route path="other-vitals/*" element={<OtherVitals />} />
        <Route path="paediatric-params/*" element={<PaediatricParams />} />
        <Route path="patient-condition/*" element={<PatientCondition />} />
        <Route path="patient-condition-check-up/*" element={<PatientConditionCheckUp />} />
        <Route path="patient-identifier-name/*" element={<PatientIdentifierName />} />
        <Route path="patient-identifier/*" element={<PatientIdentifier />} />
        <Route path="patient-identifier-type/*" element={<PatientIdentifierType />} />
        <Route path="patient-marker/*" element={<PatientMarker />} />
        <Route path="patient-nutrition-plan/*" element={<PatientNutritionPlan />} />
        <Route path="patient-procedure/*" element={<PatientProcedure />} />
        <Route path="patient-procedure-consumable/*" element={<PatientProcedureConsumable />} />
        <Route path="patient-procedure-implant/*" element={<PatientProcedureImplant />} />
        <Route path="patient-procedure-medicine/*" element={<PatientProcedureMedicine />} />
        <Route path="patient-procedure-order/*" element={<PatientProcedureOrder />} />
        <Route path="patient-procedure-plan/*" element={<PatientProcedurePlan />} />
        <Route path="patient-procedure-investigation/*" element={<PatientProcedureInvestigation />} />
        <Route path="patient-survey/*" element={<PatientSurvey />} />
        <Route path="patient-survey-sections/*" element={<PatientSurveySections />} />
        <Route path="patient-volunteer/*" element={<PatientVolunteer />} />
        <Route path="payment-scheme/*" element={<PaymentScheme />} />
        <Route path="patient-name/*" element={<PatientName />} />
        <Route path="pharmacist/*" element={<Pharmacist />} />
        <Route path="pharmacy/*" element={<Pharmacy />} />
        <Route path="pharmacy-access/*" element={<PharmacyAccess />} />
        <Route path="pharmacy-bill/*" element={<PharmacyBill />} />
        <Route path="pharmacy-bill-item/*" element={<PharmacyBillItem />} />
        <Route path="pharmacy-bill-payment/*" element={<PharmacyBillPayment />} />
        <Route path="pharmacy-consumable-bill-item/*" element={<PharmacyConsumableBillItem />} />
        <Route path="pharmacy-consumable-refund-bill-item/*" element={<PharmacyConsumableRefundBillItem />} />
        <Route path="pharmacy-consumable-stock/*" element={<PharmacyConsumableStock />} />
        <Route path="pharmacy-drug-brand-names/*" element={<PharmacyDrugBrandNames />} />
        <Route path="pharmacy-history/*" element={<PharmacyHistory />} />
        <Route path="pharmacy-hospital-association/*" element={<PharmacyHospitalAssociation />} />
        <Route path="pharmacy-implant-bill-item/*" element={<PharmacyImplantBillItem />} />
        <Route path="pharmacy-implant-refund-bill-item/*" element={<PharmacyImplantRefundBillItem />} />
        <Route path="pharmacy-implant-stock/*" element={<PharmacyImplantStock />} />
        <Route path="pharmacy-payment-history/*" element={<PharmacyPaymentHistory />} />
        <Route path="pharmacy-refund-bill/*" element={<PharmacyRefundBill />} />
        <Route path="pharmacy-refund-bill-item/*" element={<PharmacyRefundBillItem />} />
        <Route path="pharmacy-refund-payment/*" element={<PharmacyRefundPayment />} />
        <Route path="pharmacy-stock/*" element={<PharmacyStock />} />
        <Route path="pharmacy-stock-bill/*" element={<PharmacyStockBill />} />
        <Route path="pharmacy-suppliers/*" element={<PharmacySuppliers />} />
        <Route path="physio-category/*" element={<PhysioCategory />} />
        <Route path="physio-category-item/*" element={<PhysioCategoryItem />} />
        <Route path="physio-item/*" element={<PhysioItem />} />
        <Route path="physio-order/*" element={<PhysioOrder />} />
        <Route path="physio-order-item/*" element={<PhysioOrderItem />} />
        <Route path="physio-therapist/*" element={<PhysioTherapist />} />
        <Route path="post-op-instruction/*" element={<PostOPInstruction />} />
        <Route path="post-op-recovery-record/*" element={<PostOPRecoveryRecord />} />
        <Route path="post-op-surgeon-notes/*" element={<PostOPSurgeonNotes />} />
        <Route path="post-op-recovery/*" element={<PostOpRecovery />} />
        <Route path="post-op-recovery-discharge/*" element={<PostOpRecoveryDischarge />} />
        <Route path="pre-assessment/*" element={<PreAssessment />} />
        <Route path="pre-op-time-out/*" element={<PreOPTimeOut />} />
        <Route path="pre-op-addl-assessment/*" element={<PreOpAddlAssessment />} />
        <Route path="pre-op-anaesthesia-chart/*" element={<PreOpAnaesthesiaChart />} />
        <Route path="pre-op-assessment/*" element={<PreOpAssessment />} />
        <Route path="pre-op-check-list/*" element={<PreOpCheckList />} />
        <Route path="pre-op-instructions/*" element={<PreOpInstructions />} />
        <Route path="pre-op-review-pac/*" element={<PreOpReviewPAC />} />
        <Route path="pre-op-sign-in/*" element={<PreOpSignIn />} />
        <Route path="prescription/*" element={<Prescription />} />
        <Route path="prescription-spec-vital/*" element={<PrescriptionSpecVital />} />
        <Route path="pressure/*" element={<Pressure />} />
        <Route path="procedure-blood-products/*" element={<ProcedureBloodProducts />} />
        <Route path="procedure-consumable/*" element={<ProcedureConsumable />} />
        <Route path="procedure-implant/*" element={<ProcedureImplant />} />
        <Route path="procedure-medicine/*" element={<ProcedureMedicine />} />
        <Route path="procedure-monitors/*" element={<ProcedureMonitors />} />
        <Route path="procedure-price/*" element={<ProcedurePrice />} />
        <Route path="procedure-investigation/*" element={<ProcedureInvestigation />} />
        <Route path="provided-item/*" element={<ProvidedItem />} />
        <Route path="radiology-bill-item/*" element={<RadiologyBillItem />} />
        <Route path="radiology-pricing/*" element={<RadiologyPricing />} />
        <Route path="radiology-report/*" element={<RadiologyReport />} />
        <Route path="radiology-report-template/*" element={<RadiologyReportTemplate />} />
        <Route path="radiology-study/*" element={<RadiologyStudy />} />
        <Route path="recipe/*" element={<Recipe />} />
        <Route path="recipe-tags/*" element={<RecipeTags />} />
        <Route path="referral/*" element={<Referral />} />
        <Route path="relation/*" element={<Relation />} />
        <Route path="relatives/*" element={<Relatives />} />
        <Route path="reminder-options/*" element={<ReminderOptions />} />
        <Route path="reminders/*" element={<Reminders />} />
        <Route path="roles/*" element={<Roles />} />
        <Route path="room/*" element={<Room />} />
        <Route path="saluation/*" element={<Saluation />} />
        <Route path="series/*" element={<Series />} />
        <Route path="speciality-vitals/*" element={<SpecialityVitals />} />
        <Route path="study/*" element={<Study />} />
        <Route path="subscription-billing/*" element={<SubscriptionBilling />} />
        <Route path="subscription-payment/*" element={<SubscriptionPayment />} />
        <Route path="subscription-plan/*" element={<SubscriptionPlan />} />
        <Route path="survey-answer/*" element={<SurveyAnswer />} />
        <Route path="survey-comments/*" element={<SurveyComments />} />
        <Route path="survey-headers/*" element={<SurveyHeaders />} />
        <Route path="survey-input-type/*" element={<SurveyInputType />} />
        <Route path="survey-option-choice/*" element={<SurveyOptionChoice />} />
        <Route path="survey-option-group/*" element={<SurveyOptionGroup />} />
        <Route path="survey-question/*" element={<SurveyQuestion />} />
        <Route path="survey-question-option/*" element={<SurveyQuestionOption />} />
        <Route path="survey-sections/*" element={<SurveySections />} />
        <Route path="survey-units-of-measure/*" element={<SurveyUnitsOfMeasure />} />
        <Route path="template-diagnosis/*" element={<TemplateDiagnosis />} />
        <Route path="template-investigation/*" element={<TemplateInvestigation />} />
        <Route path="template-medication/*" element={<TemplateMedication />} />
        <Route path="template-prescription/*" element={<TemplatePrescription />} />
        <Route path="template-schedule/*" element={<TemplateSchedule />} />
        <Route path="treatment-history/*" element={<TreatmentHistory />} />
        <Route path="treatment-notes/*" element={<TreatmentNotes />} />
        <Route path="treatment-plan/*" element={<TreatmentPlan />} />
        <Route path="user-additional-history/*" element={<UserAdditionalHistory />} />
        <Route path="user-allergies/*" element={<UserAllergies />} />
        <Route path="user-lab-item-enum/*" element={<UserLabItemEnum />} />
        <Route path="user-lab-test-item/*" element={<UserLabTestItem />} />
        <Route path="user-panel-item/*" element={<UserPanelItem />} />
        <Route path="user-roles/*" element={<UserRoles />} />
        <Route path="user-vaccination-schedule-details/*" element={<UserVaccinationScheduleDetails />} />
        <Route path="vaccination/*" element={<Vaccination />} />
        <Route path="vaccination-schedule/*" element={<VaccinationSchedule />} />
        <Route path="vaccination-schedule-details/*" element={<VaccinationScheduleDetails />} />
        <Route path="vitals/*" element={<Vitals />} />
        <Route path="volunteer-visits/*" element={<VolunteerVisits />} />
        <Route path="ward/*" element={<Ward />} />
        <Route path="ward-charges/*" element={<WardCharges />} />
        <Route path="weight/*" element={<Weight />} />
        <Route path="wong-bakers-pain-score/*" element={<WongBakersPainScore />} />
        <Route path="entity-attribute/*" element={<EntityAttribute />} />
        <Route path="pharmacy-limit/*" element={<PharmacyLimit />} />
        <Route path="operation-theatre/*" element={<OperationTheatre />} />
        <Route path="surgical-appointment/*" element={<SurgicalAppointment />} />
        <Route path="surgical-appointment-attribute-type/*" element={<SurgicalAppointmentAttributeType />} />
        <Route path="surgical-appointment-attribute/*" element={<SurgicalAppointmentAttribute />} />
        <Route path="pharmacy-return-bill/*" element={<PharmacyReturnBill />} />
        <Route path="pharmacy-return-bill-item/*" element={<PharmacyReturnBillItem />} />
        <Route path="pharmacy-consumable-return-bill-item/*" element={<PharmacyConsumableReturnBillItem />} />
        <Route path="pharmacy-implant-return-bill-item/*" element={<PharmacyImplantReturnBillItem />} />
        <Route path="pharmacy-vendor-payment-tracker/*" element={<PharmacyVendorPaymentTracker />} />
        <Route path="op-charge/*" element={<OPCharge />} />
        <Route path="pharmacy-credit/*" element={<PharmacyCredit />} />
        <Route path="package-subscription/*" element={<PackageSubscription />} />
        <Route path="package-subscriber/*" element={<PackageSubscriber />} />
        <Route path="package-subscription-discount/*" element={<PackageSubscriptionDiscount />} />
        <Route path="package-payment-history/*" element={<PackagePaymentHistory />} />
        <Route path="patient-access-group/*" element={<PatientAccessGroup />} />
        <Route path="pharmacy-audit-summary/*" element={<PharmacyAuditSummary />} />
        <Route path="pharmacy-audit-item/*" element={<PharmacyAuditItem />} />
        <Route path="package-medicine/*" element={<PackageMedicine />} />
        <Route path="customer-care-executive/*" element={<CustomerCareExecutive />} />
        <Route path="event-image/*" element={<EventImage />} />
        <Route path="dental-tooth/*" element={<DentalTooth />} />
        <Route path="dental-surface/*" element={<DentalSurface />} />
        <Route path="dental-tooth-surface/*" element={<DentalToothSurface />} />
        <Route path="dental-mouth-item/*" element={<DentalMouthItem />} />
        <Route path="dental-surface-erosion/*" element={<DentalSurfaceErosion />} />
        <Route path="dental-exam-and-treatment/*" element={<DentalExamAndTreatment />} />
        <Route path="pharmacy-kit/*" element={<PharmacyKit />} />
        <Route path="pharmacy-kit-item/*" element={<PharmacyKitItem />} />
        <Route path="procedure-episode/*" element={<ProcedureEpisode />} />
        <Route path="patient-procedure-episode/*" element={<PatientProcedureEpisode />} />
        <Route path="treatment-procedure/*" element={<TreatmentProcedure />} />
        <Route path="pharmacy-stock-closure/*" element={<PharmacyStockClosure />} />
        <Route path="lens-specification/*" element={<LensSpecification />} />
        <Route path="lens-prescription/*" element={<LensPrescription />} />
        <Route path="op-procedure-order/*" element={<OpProcedureOrder />} />
        <Route path="op-procedure-order-item/*" element={<OpProcedureOrderItem />} />
        <Route path="appointment-episode/*" element={<AppointmentEpisode />} />
        <Route path="bleeding/*" element={<Bleeding />} />
        <Route path="cervix/*" element={<Cervix />} />
        <Route path="cycle-day/*" element={<CycleDay />} />
        <Route path="family-history/*" element={<FamilyHistory />} />
        <Route path="gynaec-history/*" element={<GynaecHistory />} />
        <Route path="medication-history/*" element={<MedicationHistory />} />
        <Route path="menses-event/*" element={<MensesEvent />} />
        <Route path="mucus/*" element={<Mucus />} />
        <Route path="ovulation/*" element={<Ovulation />} />
        <Route path="pain/*" element={<Pain />} />
        <Route path="past-medical-history/*" element={<PastMedicalHistory />} />
        <Route path="patient-symptom-history/*" element={<PatientSymptomHistory />} />
        <Route path="post-delivery-monitoring/*" element={<PostDeliveryMonitoring />} />
        <Route path="pregnancy-case/*" element={<PregnancyCase />} />
        <Route path="pregnancy-prescription/*" element={<PregnancyPrescription />} />
        <Route path="pregnancy-vaccine/*" element={<PregnancyVaccine />} />
        <Route path="habits-history/*" element={<HabitsHistory />} />
        <Route path="sexual-history/*" element={<SexualHistory />} />
        <Route path="speciality-symptom-preferences/*" element={<SpecialitySymptomPreferences />} />
        <Route path="surgical-history/*" element={<SurgicalHistory />} />
        <Route path="symptom/*" element={<Symptom />} />
        <Route path="temperature/*" element={<Temperature />} />
        <Route path="trimester-observation/*" element={<TrimesterObservation />} />
        <Route path="patient-attribute-type/*" element={<PatientAttributeType />} />
        <Route path="patient-attribute/*" element={<PatientAttribute />} />
        <Route path="paramedic/*" element={<Paramedic />} />
        <Route path="paramedic-referral/*" element={<ParamedicReferral />} />
        <Route path="paramedic-referral-charge/*" element={<ParamedicReferralCharge />} />
        <Route path="paramedic-referral-payment/*" element={<ParamedicReferralPayment />} />
        <Route path="paramedic-hospital-association/*" element={<ParamedicHospitalAssociation />} />
        <Route path="url-slug/*" element={<UrlSlug />} />
        <Route path="facility-location/*" element={<FacilityLocation />} />
        <Route path="paramedic-access/*" element={<ParamedicAccess />} />
        <Route path="pharmacy-stock-indent-item/*" element={<PharmacyStockIndentItem />} />
        <Route path="pharmacy-stock-indent-map/*" element={<PharmacyStockIndentMap />} />
        <Route path="diag-lab-inventory-type/*" element={<DiagLabInventoryType />} />
        <Route path="diag-lab-inventory/*" element={<DiagLabInventory />} />
        <Route path="diag-lab-inventory-investigation/*" element={<DiagLabInventoryInvestigation />} />
        <Route path="diag-lab-supplier/*" element={<DiagLabSupplier />} />
        <Route path="pharmacy-stock-indent/*" element={<PharmacyStockIndent />} />
        <Route path="diag-lab-inventory-checkout/*" element={<DiagLabInventoryCheckout />} />
        <Route path="language/*" element={<Language />} />
        <Route path="trimester/*" element={<Trimester />} />
        <Route path="paramedic-order/*" element={<ParamedicOrder />} />
        <Route path="doctor-language/*" element={<DoctorLanguage />} />
        <Route path="labor-incident/*" element={<LaborIncident />} />
        <Route path="labor-progression/*" element={<LaborProgression />} />
        <Route path="trimester-observation-param/*" element={<TrimesterObservationParam />} />
        <Route path="spec-vital-result/*" element={<SpecVitalResult />} />
        <Route path="admission-aux-patient/*" element={<AdmissionAuxPatient />} />
        <Route path="admission-consultant/*" element={<AdmissionConsultant />} />
        <Route path="gynaec-checklist/*" element={<GynaecChecklist />} />
        <Route path="patient-category/*" element={<PatientCategory />} />
        <Route path="misc-charges/*" element={<MiscCharges />} />
        <Route path="hospital-patient-category-attributes/*" element={<HospitalPatientCategoryAttributes />} />
        <Route path="hosp-patient-cat-misc-charges/*" element={<HospPatientCatMiscCharges />} />
        <Route path="hospital-patient-attribute/*" element={<HospitalPatientAttribute />} />
        <Route path="doctor-hospital-attribute/*" element={<DoctorHospitalAttribute />} />
        <Route path="day-off/*" element={<DayOff />} />
        <Route path="department/*" element={<Department />} />
        <Route path="nurse-department/*" element={<NurseDepartment />} />
        <Route path="department-need/*" element={<DepartmentNeed />} />
        <Route path="nurse-attribute/*" element={<NurseAttribute />} />
        <Route path="schedule/*" element={<Schedule />} />
        <Route path="shift/*" element={<Shift />} />
        <Route path="department-ward/*" element={<DepartmentWard />} />
        <Route path="payment-community/*" element={<PaymentCommunity />} />
        <Route path="scheme-community/*" element={<SchemeCommunity />} />
        <Route path="department-speciality/*" element={<DepartmentSpeciality />} />
        <Route path="diag-lab-inventory-bill/*" element={<DiagLabInventoryBill />} />
        <Route path="symptom-attribute-preference/*" element={<SymptomAttributePreference />} />
        <Route path="symptom-attribute/*" element={<SymptomAttribute />} />
        <Route path="patient-symptom-attribute/*" element={<PatientSymptomAttribute />} />
        <Route path="concept-terms/*" element={<ConceptTerms />} />
        <Route path="user-attribute/*" element={<UserAttribute />} />
        <Route path="pharmacy-consumer/*" element={<PharmacyConsumer />} />
        <Route path="pharmacy-external-order/*" element={<PharmacyExternalOrder />} />
        <Route path="pharmacy-external-order-item/*" element={<PharmacyExternalOrderItem />} />
        <Route path="pharmacy-external-order-shipment/*" element={<PharmacyExternalOrderShipment />} />
        <Route path="pharmacy-external-order-shipment-item/*" element={<PharmacyExternalOrderShipmentItem />} />
        <Route path="eye/*" element={<Eye />} />
        <Route path="pharmacy-misc-bill-item/*" element={<PharmacyMiscBillItem />} />
        <Route path="tumor-measurement/*" element={<TumorMeasurement />} />
        <Route path="clinical-dictionary-type/*" element={<ClinicalDictionaryType />} />
        <Route path="clinical-dictionary/*" element={<ClinicalDictionary />} />
        <Route path="tumor/*" element={<Tumor />} />
        <Route path="tumor-source/*" element={<TumorSource />} />
        <Route path="treatment-template/*" element={<TreatmentTemplate />} />
        <Route path="treatment-template-component/*" element={<TreatmentTemplateComponent />} />
        <Route path="regimen/*" element={<Regimen />} />
        <Route path="regimen-checklist-item/*" element={<RegimenChecklistItem />} />
        <Route path="radiation-type/*" element={<RadiationType />} />
        <Route path="radiation-technique/*" element={<RadiationTechnique />} />
        <Route path="dosage-guideline/*" element={<DosageGuideline />} />
        <Route path="dosage-dilution/*" element={<DosageDilution />} />
        <Route path="frequency/*" element={<Frequency />} />
        <Route path="sequence/*" element={<Sequence />} />
        <Route path="regimen-drug/*" element={<RegimenDrug />} />
        <Route path="radiation-session/*" element={<RadiationSession />} />
        <Route path="organ-at-risk/*" element={<OrganAtRisk />} />
        <Route path="radiation-constraint/*" element={<RadiationConstraint />} />
        <Route path="radiation-beam-parameter/*" element={<RadiationBeamParameter />} />
        <Route path="radiation-dosimetry/*" element={<RadiationDosimetry />} />
        <Route path="regimen-cycle/*" element={<RegimenCycle />} />
        <Route path="regimen-adverse-event/*" element={<RegimenAdverseEvent />} />
        <Route path="drug-constraint/*" element={<DrugConstraint />} />
        <Route path="treatment-delivery-plan/*" element={<TreatmentDeliveryPlan />} />
        <Route path="treatment-regimen/*" element={<TreatmentRegimen />} />
        <Route path="treatment-cycle/*" element={<TreatmentCycle />} />
        <Route path="treatment-cycle-check-list-item/*" element={<TreatmentCycleCheckListItem />} />
        <Route path="treatment-drug/*" element={<TreatmentDrug />} />
        <Route path="treatment-radiation/*" element={<TreatmentRadiation />} />
        <Route path="treatment-radiation-beam-param/*" element={<TreatmentRadiationBeamParam />} />
        <Route path="treatment-radiation-dosimetry/*" element={<TreatmentRadiationDosimetry />} />
        <Route path="treatment-organ-at-risk/*" element={<TreatmentOrganAtRisk />} />
        <Route path="treatment-tumor/*" element={<TreatmentTumor />} />
        <Route path="treatment-radiation-technique/*" element={<TreatmentRadiationTechnique />} />
        <Route path="treatment-contouring/*" element={<TreatmentContouring />} />
        <Route path="treatment-assessment/*" element={<TreatmentAssessment />} />
        <Route path="treatment-adverse-event/*" element={<TreatmentAdverseEvent />} />
        <Route path="tumor-board/*" element={<TumorBoard />} />
        <Route path="tumor-board-member/*" element={<TumorBoardMember />} />
        <Route path="tumor-staging/*" element={<TumorStaging />} />
        <Route path="tumor-board-occurrence-participant/*" element={<TumorBoardOccurrenceParticipant />} />
        <Route path="tumor-board-outcome/*" element={<TumorBoardOutcome />} />
        <Route path="tumor-board-participant-outcome/*" element={<TumorBoardParticipantOutcome />} />
        <Route path="tumor-board-referral/*" element={<TumorBoardReferral />} />
        <Route path="tumor-board-occurrence/*" element={<TumorBoardOccurrence />} />
        <Route path="tumor-board-patient/*" element={<TumorBoardPatient />} />
        <Route path="doctor-availability-slot/*" element={<DoctorAvailabilitySlot />} />
        <Route path="bed-allotment-charge/*" element={<BedAllotmentCharge />} />
        <Route path="equipment-allotment-charge/*" element={<EquipmentAllotmentCharge />} />
        <Route path="patient-procedure-charge/*" element={<PatientProcedureCharge />} />
        <Route path="product-tag/*" element={<ProductTag />} />
        <Route path="tenant-payment-gateway/*" element={<TenantPaymentGateway />} />
        <Route path="payment-gateway/*" element={<PaymentGateway />} />
        <Route path="tenant-gateway-transaction/*" element={<TenantGatewayTransaction />} />
        <Route path="pharmacy-supplier-attribute/*" element={<PharmacySupplierAttribute />} />
        <Route path="intra-op-investigation/*" element={<IntraOPInvestigation />} />
        <Route path="product-attribute-type/*" element={<ProductAttributeType />} />
        <Route path="product-attribute/*" element={<ProductAttribute />} />
        <Route path="sample-container-type/*" element={<SampleContainerType />} />
        <Route path="hospital-procedure-speciality/*" element={<HospitalProcedureSpeciality />} />
        <Route path="work-flow-protocol/*" element={<WorkFlowProtocol />} />
        <Route path="work-flow-step/*" element={<WorkFlowStep />} />
        <Route path="work-flow-protocol-log/*" element={<WorkFlowProtocolLog />} />
        <Route path="accounting-currency/*" element={<AccountingCurrency />} />
        <Route path="accounting-transaction/*" element={<AccountingTransaction />} />
        <Route path="accounting-reconciliation/*" element={<AccountingReconciliation />} />
        <Route path="accounting-collection-ledger/*" element={<AccountingCollectionLedger />} />
        <Route path="accounting-transaction-bill/*" element={<AccountingTransactionBill />} />
        <Route path="accounting-expense-ledger/*" element={<AccountingExpenseLedger />} />
        <Route path="accounting-tax/*" element={<AccountingTax />} />
        <Route path="work-flow-step-log/*" element={<WorkFlowStepLog />} />
        <Route path="accounting-bank-account/*" element={<AccountingBankAccount />} />
        <Route path="pharmacy-sale-credit/*" element={<PharmacySaleCredit />} />
        <Route path="sample-container-test-sample/*" element={<SampleContainerTestSample />} />
        <Route path="operation-theatre-equipment/*" element={<OperationTheatreEquipment />} />
        <Route path="pharmacy-sale-credit-payment-tracker/*" element={<PharmacySaleCreditPaymentTracker />} />
        <Route path="diaglab-department-access/*" element={<DiaglabDepartmentAccess />} />
        <Route path="lab-test-item-attribute/*" element={<LabTestItemAttribute />} />
        <Route path="rx-calculator-formula/*" element={<RxCalculatorFormula />} />
        <Route path="diaglab-test-threshold/*" element={<DiaglabTestThreshold />} />
        <Route path="treatment-session-vitals/*" element={<TreatmentSessionVitals />} />
        <Route path="regimen-investigation/*" element={<RegimenInvestigation />} />
        <Route path="treatment-regimen-investigation/*" element={<TreatmentRegimenInvestigation />} />
        <Route path="treatment-regimen-investigation-obs/*" element={<TreatmentRegimenInvestigationObs />} />
        <Route path="catalog-definitions/*" element={<CatalogDefinitions />} />
        <Route path="organism/*" element={<Organism />} />
        <Route path="antibiotic/*" element={<Antibiotic />} />
        <Route path="lab-test-item-organism-antibiotic/*" element={<LabTestItemOrganismAntibiotic />} />
        <Route path="patient-organism-antibiotic-susceptibility/*" element={<PatientOrganismAntibioticSusceptibility />} />
        <Route path="resistance-trend/*" element={<ResistanceTrend />} />
        <Route path="blood-bank-inventory/*" element={<BloodBankInventory />} />
        <Route path="blood-bank-request/*" element={<BloodBankRequest />} />
        <Route path="blood-inventory-request-map/*" element={<BloodInventoryRequestMap />} />
        <Route path="blood-bank/*" element={<BloodBank />} />
        <Route path="blood-bank-employee/*" element={<BloodBankEmployee />} />
        <Route path="blood-donation/*" element={<BloodDonation />} />
        <Route path="blood-donor-fitness/*" element={<BloodDonorFitness />} />
        <Route path="health-camp/*" element={<HealthCamp />} />
        <Route path="blood-inventory-investigation/*" element={<BloodInventoryInvestigation />} />
        <Route path="blood-bank-investigation-list/*" element={<BloodBankInvestigationList />} />
        <Route path="blood-bank-access/*" element={<BloodBankAccess />} />
        <Route path="blood-bank-association/*" element={<BloodBankAssociation />} />
        <Route path="blood-bank-adverse-event/*" element={<BloodBankAdverseEvent />} />
        <Route path="integration-channel/*" element={<IntegrationChannel />} />
        <Route path="integration-endpoint/*" element={<IntegrationEndpoint />} />
        <Route path="integration-endpoint-attribute/*" element={<IntegrationEndpointAttribute />} />
        <Route path="integration-template/*" element={<IntegrationTemplate />} />
        <Route path="tenant-integration-channel/*" element={<TenantIntegrationChannel />} />
        <Route path="tenant-integration-endpoint-attribute/*" element={<TenantIntegrationEndpointAttribute />} />
        <Route path="tenant-integration-template/*" element={<TenantIntegrationTemplate />} />
        <Route path="communication-log/*" element={<CommunicationLog />} />
        <Route path="data-category/*" element={<DataCategory />} />
        <Route path="integration-template-category/*" element={<IntegrationTemplateCategory />} />
        <Route path="tenant-integration-template-category/*" element={<TenantIntegrationTemplateCategory />} />
        <Route path="hospital-procedure-item/*" element={<HospitalProcedureItem />} />
        <Route path="health-camp-participant/*" element={<HealthCampParticipant />} />
        <Route path="health-camp-transaction/*" element={<HealthCampTransaction />} />
        <Route path="approved-refund/*" element={<ApprovedRefund />} />
        <Route path="external-referral/*" element={<ExternalReferral />} />
        <Route path="health-camp-registration/*" element={<HealthCampRegistration />} />
        <Route path="tenant/*" element={<Tenant />} />
        <Route path="tenant-employee/*" element={<TenantEmployee />} />
        <Route path="tenant-access/*" element={<TenantAccess />} />
        <Route path="tenant-association/*" element={<TenantAssociation />} />
        <Route path="tinymedic-patient-order/*" element={<TinymedicPatientOrder />} />
        <Route path="tenant-bids/*" element={<TenantBids />} />
        <Route path="tenant-bid-item/*" element={<TenantBidItem />} />
        <Route path="tenant-bid-payment/*" element={<TenantBidPayment />} />
        <Route path="tenant-bid-shipment/*" element={<TenantBidShipment />} />
        <Route path="tinymedic-patient-order-file/*" element={<TinymedicPatientOrderFile />} />
        <Route path="doctor-regular-medicine/*" element={<DoctorRegularMedicine />} />
        <Route path="doctor-regular-investigation/*" element={<DoctorRegularInvestigation />} />
        {/* jhipster-needle-add-route-path - JHipster will add routes here */}
      </ErrorBoundaryRoutes>
    </div>
  );
};
